import './style.scss';

import { Box, Link } from '@mui/material';
import { FC, ReactElement, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import DiagnosticsDialog from '../../pages/diagnostics/diagnostics-dialog';
import ConnectionStatus from '../connectionStatus/connection-status';

interface IProps {
  renderConnectionStatus?: boolean | true;
}

export const ImmersiveFooter: FC<IProps> = (props): ReactElement => {
  const renderConnectionStatus =
    props.renderConnectionStatus === undefined ? true : props.renderConnectionStatus;

  // Open the diagnostics panel in a modal so the user stays on the page. The
  // standalone /diagnostics route remains as the fallback when the app will not
  // load at all (a modal cannot help then).
  const [diagnosticsOpen, setDiagnosticsOpen] = useState(false);

  return (
    <Box className="immersive-footer" component="footer">
      <Box>{renderConnectionStatus && <ConnectionStatus />}</Box>
      <Box className="links" sx={{ flexGrow: 1 }}></Box>
      <Box className="links">
        <Link component="button" type="button" onClick={() => setDiagnosticsOpen(true)}>
          Diagnostics
        </Link>
      </Box>
      <DiagnosticsDialog open={diagnosticsOpen} onClose={() => setDiagnosticsOpen(false)} />
      <Box className="links">
        <Link component={RouterLink} to="/privacy-policy">
          Privacy Policy
        </Link>
      </Box>
      <Box className="links">
        <Link component={RouterLink} to="/terms-of-use">
          Terms of service
        </Link>
      </Box>
      <Box className="links">
        <Link component={RouterLink} to="/cookie-policy">
          Cookie Policy
        </Link>
      </Box>
      <Box className="links">
        <Link
          component={RouterLink}
          to="https://www.immersive-finance.com/#contact"
          target="_blank"
        >
          Contact us
        </Link>
      </Box>
    </Box>
  );
};

export default ImmersiveFooter;
